module.exports = __webpack_public_path__ + "static/media/kota.f705b0a1.png";